import { StyleSheet } from 'react-native';
import {
  REVIEW_PROMPT_COLORS as C,
  REVIEW_PROMPT_LAYOUT as L,
} from './reviewPromptModal.constants';

/**
 * Dark-committed palette from the design handoff — deliberately not themed
 * (the celebration card looks the same in light and dark mode).
 */
export const getReviewPromptModalStyles = () => {
  return StyleSheet.create({
    // Card (width set inline by the component, capped to the viewport)
    cardWrap: {
      alignItems: 'center',
    },
    card: {
      width: '100%',
      borderRadius: 16,
      borderWidth: 1.5,
      borderColor: C.ACCENT,
      paddingTop: 40,
      paddingBottom: 24,
      paddingHorizontal: 20,
      overflow: 'visible',
      shadowColor: C.ACCENT,
      shadowOpacity: 0.35,
      shadowRadius: 24,
      shadowOffset: { width: 0, height: 6 },
      elevation: 12,
    },
    cardGradient: {
      ...StyleSheet.absoluteFillObject,
      borderRadius: 14,
    },

    // Trophy badge overlapping the top edge
    trophyBadge: {
      position: 'absolute',
      top: -30,
      alignSelf: 'center',
      width: 60,
      height: 60,
      borderRadius: 30,
      backgroundColor: C.BADGE_BG,
      borderWidth: 2,
      borderColor: C.ACCENT,
      alignItems: 'center',
      justifyContent: 'center',
      shadowColor: C.ACCENT,
      shadowOpacity: 0.4,
      shadowRadius: 10,
      shadowOffset: { width: 0, height: 0 },
      elevation: 8,
      zIndex: 2,
    },

    // Close (X)
    closeButton: {
      position: 'absolute',
      top: 12,
      right: 12,
      width: 40,
      height: 40,
      borderRadius: 20,
      backgroundColor: C.CLOSE_BG,
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 2,
    },
    closeButtonPressed: {
      opacity: 0.75,
    },

    // Copy
    title: {
      marginTop: 4,
      textAlign: 'center',
      fontSize: 27,
      lineHeight: 31,
      fontWeight: '800',
      letterSpacing: -0.3,
      color: C.TITLE,
    },
    subtitle: {
      marginTop: 8,
      alignSelf: 'center',
      maxWidth: 300,
      textAlign: 'center',
      fontSize: 14.5,
      lineHeight: 21,
      fontWeight: '500',
      color: C.SUBTITLE,
    },
    subtitleHighlight: {
      color: C.ACCENT,
      fontWeight: '700',
    },

    // Mascot stage
    stage: {
      height: L.STAGE_HEIGHT,
      marginTop: 6,
      alignItems: 'center',
      justifyContent: 'flex-end',
      width: '100%',
    },
    stageGlow: {
      position: 'absolute',
      bottom: 0,
      alignSelf: 'center',
    },
    coin: {
      position: 'absolute',
    },
    coinImage: {
      width: '100%',
      height: '100%',
    },
    twinkle: {
      position: 'absolute',
    },
    monkey: {
      width: L.MONKEY_SIZE,
      height: L.MONKEY_SIZE,
    },

    // Stars
    starsRow: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 6,
      marginTop: 16,
    },
    starButton: {
      padding: 4,
    },
    starButtonPressed: {
      transform: [{ scale: 0.9 }],
    },

    // Bottom copy
    goldLine: {
      marginTop: 16,
      textAlign: 'center',
      fontSize: 18,
      fontWeight: '800',
      color: C.GOLD,
    },
    subLine: {
      marginTop: 6,
      textAlign: 'center',
      fontSize: 14,
      fontWeight: '500',
      color: C.BODY,
    },

    // CTA
    ctaWrap: {
      marginTop: 18,
      width: '100%',
    },
    ctaPulseRing: {
      ...StyleSheet.absoluteFillObject,
      borderRadius: 12,
      borderWidth: 2,
      borderColor: C.ACCENT,
    },
    ctaButton: {
      width: '100%',
      minHeight: 56,
      borderRadius: 12,
      overflow: 'hidden',
      alignItems: 'center',
      justifyContent: 'center',
    },
    ctaButtonPressed: {
      transform: [{ scale: 0.97 }],
    },
    ctaGradient: {
      ...StyleSheet.absoluteFillObject,
    },
    ctaContent: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 10,
      paddingHorizontal: 16,
      paddingVertical: 14,
    },
    ctaCoin: {
      width: 26,
      height: 26,
    },
    ctaLabel: {
      fontSize: 19,
      fontWeight: '800',
      color: C.CTA_TEXT,
    },

    // Post-accept toast line
    toast: {
      marginTop: 12,
      textAlign: 'center',
      fontSize: 14,
      fontWeight: '700',
      color: C.TOAST,
    },
  });
};
